exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block-renderer h1{font-size:1.5em}.block-renderer h1,.block-renderer h2{font-weight:600;margin-top:.5em;margin-bottom:.25em}.block-renderer h2{font-size:1.3em}.block-renderer h3{font-size:1.15em}.block-renderer h3,.block-renderer h4{font-weight:600;margin-top:.5em;margin-bottom:.25em}.block-renderer h4{font-size:1.05em}.block-renderer h5{font-size:.95em}.block-renderer h5,.block-renderer h6{font-weight:600;margin-top:.5em;margin-bottom:.25em}.block-renderer h6{font-size:.85em}.block-renderer ul{padding-left:1.4em;margin-bottom:.5em}.block-renderer a{color:#007bff;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-07576486","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Assets/components/Common/BlockRenderer.vue
// module id = 722
// module chunks = 0 1